export enum Queries {
    getCompanyFilters = 'getCompanyFilters',
    getDiversityCompanyProfiles = 'getDiversityCompanyProfiles',
    getDiversityCompanyProfilesOptions = 'getDiversityCompanyProfilesOptions',
    getInclusionCompanyProfiles = 'getInclusionCompanyProfiles',
    getInclusionCompanyProfilesOptions = 'getInclusionCompanyProfilesOptions',
    getFreeTextsFilters = 'getFreeTextsFilters',
    getFreeTexts = 'getFreeTexts',
    getBespokeFreeTexts = 'getBespokeFreeTexts',
    getNationalBenchmarks = 'getNationalBenchmarks',
    getIndustryBenchmarks = 'getIndustryBenchmarks',
    getBlogs = 'getBlogs',
    getPrograms = 'getPrograms',
    getTools = 'getTools',
    getAllTools = 'getAllTools',
    getPeopleSurveyed = 'getPeopleSurveyed',
    getPeopleSurveyedByRole = 'getPeopleSurveyedByRole',
    getEventReminders = 'getEventReminders',
    getDiversityBreakdownByRole = 'getDiversityBreakdownByRole',
    getInclusionInsights = 'getInclusionInsights',
    getInclusionHeatmap = 'getInclusionHeatmap',
    getDiversityTable = 'getDiversityTable',
    getReports = 'getReports',
    getMyReports = 'getMyReports',
    getProgramFilters = 'getProgramFilters',
    getToolsFilters = 'getToolsFilters',
    getAllTrainings = 'getAllTrainings',
    getUserMetadata = 'getUserMetadata',
    getSurveyInformation = 'surveyInformation',
    getAnnouncements = 'getAnnouncements',
    getDEISummary = 'getDEISummary',
    getPastSurveyInformation = 'getPastSurveyInformation',
    getInsipirationalQuotes = 'getInsipirationalQuotes',
    getFeedbackBanner = 'getFeedbackBanner',
    getRiskBanner = 'getRiskBanner',
    getAnalyzeLanding = 'getAnalyzeLanding',
    getDiversityData = 'getDiversityData',
    getDiversityDataOverTime = 'getDiversityDataOverTime',
    getInclusionData = 'getInclusionData',
    getInclusionDataOverTime = 'getInclusionDataOverTime',
    getInclusionPanelData = 'getInclusionPanelData',
}
